export const SITE = {
  name: "Serene Mind Place",
  therapist: "Pratyusha Nagisetty",
  role: "Psychologist · MPhil Clinical Psychology · MSc Psychology",
  tagline: "Trauma-Informed · Eclectic Approach · Individual & Couples Therapy · CBT & DBT",
  email: "pratyusha.nagisetty@outlook.com",
  phone: "083176 34326",
  phoneTel: "+918317634326",
  instagram: "https://instagram.com/serenemindplace",
  instagramHandle: "@serenemindplace",
  address: "Telecom Officers Complex, Road 92, Filmnagar, Jubilee Hills, Hyderabad, Telangana 500033",
  hours: "Mon – Sat · Closes 7:30 PM",
  rating: "5.0",
  reviewCount: 4,
  experience: "3 yrs",
  sessionDuration: "50-60 minutes",
  languages: ["Telugu", "Hindi", "English"],
  maps: "https://www.google.com/maps/search/?api=1&query=Serene+Mind+Place+Counselling+Jubilee+Hills+Hyderabad",
};

export const INSTAGRAM_POSTS = [
  { src: "/instagram/therapy-room.jpg", alt: "A calm corner of the Serene Mind Place studio", caption: "The studio corner" },
  { src: "/instagram/affirmation.jpg", alt: "You are allowed to rest — affirmation card", caption: "A gentle reminder" },
  { src: "/instagram/journal-tea.jpg", alt: "Journal and herbal tea flat lay", caption: "Slow mornings" },
  { src: "/instagram/two-chairs.jpg", alt: "Two chairs in the counselling room", caption: "A safe space for two" },
  { src: "/instagram/breathe.jpg", alt: "Breathe illustration in pastel tones", caption: "Breathe with us" },
  { src: "/instagram/plant-light.jpg", alt: "Plants in soft morning light", caption: "Morning light" },
];

export const CREDENTIALS = [
  "MPhil in Clinical Psychology",
  "RCI Licensed",
  "MSc in Psychology",
  "3 years clinical & counselling experience",
];

export const APPROACH = [
  "Person-Centred",
  "Trauma-Informed",
  "Cognitive Behavioral Therapy (CBT)",
  "Dialectical Behavior Therapy (DBT)",
  "Psychodynamic Insight Work",
  "Schema Therapy",
  "Gottman Method (Couples)",
  "Family Therapy",
  "Systems Therapy",
  "Psychometric Assessments",
];

export const IMAGES = {
  office: "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  nook: "https://images.unsplash.com/photo-1754037783933-c25ff9f68f87?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  portrait: "https://images.unsplash.com/photo-1656404256001-2ddddacd050f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  leaf: "https://images.unsplash.com/photo-1679060170179-c384186c87ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  shadow: "https://images.unsplash.com/photo-1674708271645-4d77f9d68707?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const SERVICES = [
  { key: "anxiety", title: "Anxiety & GAD", cat: "Individual", tone: "sage", desc: "Calm generalized anxiety and excessive worry, and rebuild steady confidence." },
  { key: "depression", title: "Depression & Low Mood", cat: "Individual", tone: "blue", desc: "Gentle, evidence-based paths through major depressive episodes back toward momentum." },
  { key: "stress", title: "Stress & Burnout", cat: "Individual", tone: "yellow", desc: "Recover from chronic overwhelm and rebuild sustainable energy and boundaries." },
  { key: "ocd", title: "OCD", cat: "Individual", tone: "peach", desc: "Ease intrusive thoughts and compulsions with structured, compassionate care." },
  { key: "phobias", title: "Phobias & Avoidance", cat: "Individual", tone: "sage", desc: "Soften fear responses and avoidance behaviours at a pace that feels safe." },
  { key: "trauma", title: "Trauma & Inner-Child Work", cat: "Individual", tone: "blue", desc: "Process past trauma, attachment wounds and inner-child healing, safely." },
  { key: "selfesteem", title: "Self-Esteem & Identity", cat: "Individual", tone: "peach", desc: "Work through identity difficulties and rebuild a kinder relationship with yourself." },
  { key: "assessments", title: "Psychometric Assessments", cat: "Individual", tone: "yellow", desc: "Structured assessments for diagnostic clarity and deeper psychological insight." },
  { key: "emotional", title: "Emotional Dysregulation", cat: "Mood", tone: "peach", desc: "Learn to name, regulate and soften overthinking and overwhelming emotions." },
  { key: "mood", title: "Mood Disorders", cat: "Mood", tone: "blue", desc: "Stabilise emotional weather with sustainable daily anchors." },
  { key: "bpd", title: "BPD & Personality Patterns", cat: "Mood", tone: "yellow", desc: "Skills-based care for BPD, dependent and avoidant patterns, and intensity." },
  { key: "couples", title: "Couples Therapy", cat: "Couples", tone: "sage", desc: "Rebuild communication, resolve conflict and reconnect — together." },
  { key: "relationship", title: "Relational Distress", cat: "Couples", tone: "peach", desc: "Untangle communication issues and relational distress, together or solo." },
  { key: "child", title: "Behavioural Issues in Children", cat: "Youth", tone: "yellow", desc: "Warm, patient support for behavioural concerns in children." },
  { key: "adhd", title: "ADHD Support", cat: "Youth", tone: "blue", desc: "Understand your patterns — not generic advice, but your rhythm." },
  { key: "adolescent", title: "Adolescent Concerns", cat: "Youth", tone: "sage", desc: "A safe space for teens navigating identity and pressure." },
  { key: "family", title: "Family Problems", cat: "Family", tone: "peach", desc: "Repair communication and rebuild trust within the home." },
  { key: "online", title: "Online Counselling", cat: "Family", tone: "blue", desc: "The same warm, private care — from wherever you feel safe." },
];

export const CONSULTATIONS = [
  { key: "individual", title: "Individual Consultation", icon: "user", tone: "sage",
    blurb: "A space to understand your concerns, explore next steps and see if we're a good fit.",
    online: "₹800", offline: "₹1,000" },
  { key: "couples", title: "Couples Consultation", icon: "users", tone: "blush",
    blurb: "A space to discuss your concerns as a couple, understand your needs and explore next steps.",
    online: "₹800", offline: "₹1,000" },
];

export const PACKAGES = [
  { key: "foundation", category: "individual", name: "Foundation Package", discount: "10% OFF", sessions: "5 sessions · 1 hour each",
    online: { total: "₹3,600", per: "₹720", paise: 360000 }, offline: { total: "₹4,500", per: "₹900", paise: 450000 },
    points: [
      "Space to talk, vent and process at your own pace",
      "Explore recurring difficulties and deeper patterns",
      "Schema-informed work towards healthier behaviours",
      "Builds self-understanding to handle future challenges",
    ] },
  { key: "growth", category: "individual", name: "Growth Package", discount: "20% OFF", sessions: "10 sessions · 1 hour each",
    online: { total: "₹6,400", per: "₹640", paise: 640000 }, offline: { total: "₹8,000", per: "₹800", paise: 800000 },
    points: [
      "Structured and problem-focused therapeutic work",
      "Draws from CBT and ACT principles",
      "Build practical skills for emotion regulation",
      "More time for deeper work and stronger new patterns",
    ] },
  { key: "couples_connection", category: "couples", name: "Couples Connection", discount: "10% OFF", sessions: "5 sessions · 1 hour each",
    online: { total: "₹3,600", per: "₹720", paise: 360000 }, offline: { total: "₹4,500", per: "₹900", paise: 450000 },
    points: [
      "Understand your unique relationship pattern",
      "Improve communication and emotional understanding",
      "Develop healthier ways of managing conflict",
      "Set shared goals for a more fulfilling relationship",
    ] },
  { key: "couples_growth", category: "couples", name: "Couples Growth", discount: "20% OFF", sessions: "10 sessions · 1 hour each",
    online: { total: "₹6,400", per: "₹640", paise: 640000 }, offline: { total: "₹8,000", per: "₹800", paise: 800000 },
    points: [
      "Explore recurring relationship patterns in depth",
      "Strengthen communication and emotional connection",
      "Work on trust, boundaries and conflict resolution",
      "Build skills for a healthier, supportive partnership",
    ] },
];

export const FLASH = {
  key: "flash", name: "Flash Focus", sessions: "6 sessions · 30 minutes each",
  total: "₹3,600", per: "₹600", paise: 360000,
  points: [
    "Designed to work on a specific, clearly identified issue",
    "Solution-focused approach inspired by SFBT principles",
    "Practical techniques, exercises and real-life application",
    "A significant part happens between sessions through practice",
  ],
};

export const COUPLES = {
  intro: "Couples work here blends Emotionally Focused Therapy (EFT), the Gottman Method and ACT — so you don't just resolve one fight, you rebuild how you connect.",
  modalities: ["Emotionally Focused Therapy (EFT)", "Gottman Method", "ACT for couples"],
  problems: [
    "Communication breakdowns & recurring fights",
    "Growing emotional distance or feeling unseen",
    "Trust, jealousy & rebuilding after betrayal",
    "Intimacy, affection & mismatched needs",
    "Parenting, family & in-law conflict",
    "Life transitions, stress & drifting apart",
  ],
};

export const ABOUT_ME = {
  kicker: "In my own words",
  lines: [
    "I believe healing stands on two quiet pillars — moving toward what you value, and meeting yourself with compassion.",
    "I work from a belief in an inner core of goodness in each person. Therapy, for me, is about moving beyond inherited conditioning and towards what we truly need, value, and cherish — building a life that feels richer, more meaningful, and more our own.",
    "My work, with you and within myself, is to help us find our own growth and pass that gift on — not to prove we're \u2018enough\u2019, but for the simple fulfilment of becoming.",
    "We aren't defined by our outcomes — but by faith in our already-present human good-enoughness, guided by our true north of good intentions, with care for the impact we leave and the heartfulness to show up, even if imperfectly.",
  ],
};

export const MANIFESTO = [
  { n: "01", title: "Deep Listening & Personalisation", body: "No scripts, no generic advice. Every session begins by understanding your specific patterns, history and the words you actually use — tailored to your unique pace." },
  { n: "02", title: "A Safe & Non-Judgmental Sanctuary", body: "Confidentiality and warmth come first. This is a space where you can speak freely, reflect deeply, and feel genuinely supported — nothing you feel is too much." },
  { n: "03", title: "Evidence-Based & Trauma-Informed", body: "Grounded in CBT, DBT, Schema Therapy and psychodynamic insight work — with Gottman Method couples therapy and other systemic approaches for relationships. Practical, affirming tools that meet you where you are, blending structure with flexibility." },
  { n: "04", title: "Empowering Autonomy & Resilience", body: "Therapy isn't about fixing you. Together we explore the patterns, pain, and possibilities — so you leave more capable, with compassion and clarity." },
];

export const REVIEWS = [
  { name: "Pavankumar Baswani", meta: "3 reviews", topic: "Decision Making",
    text: "An AMAZING experience with therapist Pratyusha Nagisetty. Helped me in figuring out things, clarity on decision making. I would recommend everyone to meet a person like her at least once in their lifetime.",
    reply: "Thank you for your kind words Pavan. Glad I could be of help. All the best for your future. :)" },
  { name: "Sun", meta: "1 review", topic: "ADHD",
    text: "I contacted Pratyusha regarding my ADHD-related issues, and I had a really good experience with her. She took the time to patiently understand my specific problems and patterns instead of giving generic advice.",
    reply: "Thank you for your kind words. Happy to be of help. :)" },
  { name: "Akhil. B. Modi", meta: "Local Guide · 24 reviews · 9 photos", topic: "Emotional Healing",
    text: "She is so nice and helps you in whatever way possible. Kindly do visit or book online. Mental health is so much important.",
    reply: "Thank you. Glad that I could be of help. :)" },
  { name: "Verified Client", meta: "Google review", topic: "Relationship Clarity",
    text: "A calm, thoughtful space that genuinely helped me see things clearly. Highly recommend Serene Mind Place for anyone seeking real support.",
    reply: "Thank you so much for trusting us with your journey. :)" },
];

export const TONE_CLASS = {
  sage: "bg-[#DFF0C4] border-[#C9DFAC]",
  peach: "bg-[#FFEFDF] border-[#FFC9A0]",
  blue: "bg-[#D8E5ED]/60 border-[#B8D1E0]",
  yellow: "bg-[#F7EBC6]/70 border-[#EADB9B]",
  blush: "bg-[#FBEEF2] border-[#EBD4DC]",
};
